import { SignInForm } from '../components/SignInForm';
import { SignUpHeader } from '../components/SignUpHeader';
import { AuthTabs } from '../components/AuthTabs';

export default function SignInPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Role switching is handled by the tabs below, so the header's
          built-in switch button is hidden to avoid duplicate controls. */}
      <SignUpHeader mode="signup" showSwitchButton={false} />

      <main className="flex flex-col items-center pt-12 pb-24 px-4 mx-auto w-full">
        <AuthTabs mode="signin" active="customer" />
        <SignInForm />
      </main>
    </div>
  );
}
